import { useEffect } from 'react';
import { NOVEDADES_POSTER, NOVEDADES_VIDEO_URL } from '@alexiarest/shared';
import { BotonesTiendas } from '../BotonesTiendas';
import './novedades.css';

/**
 * /novedades (18 oct 2026): la página del vídeo «Alexia tiene nueva cara».
 * Es el enlace de la miniatura del correo (un correo no reproduce vídeo).
 * Pública, sin sesión, como /descargar y /costeo.
 */
export function NovedadesPage(): JSX.Element {
  useEffect(() => {
    const antes = document.title;
    document.title = 'Alexia tiene nueva cara · Alexia Rest';
    return () => { document.title = antes; };
  }, []);
  return (
    <main className="novedades-pagina">
      <div className="novedades-pagina__card">
        <div className="novedades-pagina__marca">
          <img className="novedades-pagina__logo logo-tema--claro" src="/logo/logotipo-claro.svg" alt="Alexia Rest" width={150} height={33} />
          <img className="novedades-pagina__logo logo-tema--oscuro" src="/logo/logotipo-oscuro.svg" alt="" aria-hidden="true" width={150} height={33} />
        </div>
        <h1 className="novedades-pagina__title">Alexia tiene nueva cara</h1>
        <p className="novedades-pagina__lead"><b>Tus datos están todos igual: no se ha perdido nada.</b> Cambió cómo se ve y dónde está cada cosa.</p>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption -- los subtítulos van dentro del vídeo */}
        <video src={NOVEDADES_VIDEO_URL} poster={NOVEDADES_POSTER} controls playsInline preload="metadata" />
        <div className="novedades-pagina__acciones">
          <a className="novedades-pagina__entrar" href="/">Entrar a Alexia</a>
          <BotonesTiendas alto={44} />
        </div>
      </div>
    </main>
  );
}
